var React = require('react');
var ReactNative = require('react-native');

var {
  AppRegistry,
  View,
  Animated,
  StyleSheet,
} = ReactNative;

var Meter = require("create-react-class")(
{
  getDefaultProps : function()
  {
    return {
      outerColor: 'red',
      innerColor: 'blue',
      height: 20,
      initialPercent: 0,
      flexResolution: 100,
    }
  },

  getInitialState : function()
  {
    var flexPositive = Math.round(this.props.flexResolution * Math.min(this.props.initialPercent,1));
    var flexNegative = this.props.flexResolution - flexPositive;
    return {
      flexPositive: new Animated.Value(flexPositive),
      flexNegative: new Animated.Value(flexNegative),
    }
  },

  componentDidMount : function()
  {
  },

  componentWillReceiveProps : function(newProps)
  {
    if( typeof newProps.initialPercent !== 'undefined' && newProps.initialPercent != this.props.initialPercent )
    {
      var flexPositive = Math.round(this.props.flexResolution * Math.min(newProps.initialPercent,1));
      var flexNegative = this.props.flexResolution - flexPositive;

      this.setState({
        flexPositive: new Animated.Value(flexPositive),
        flexNegative: new Animated.Value(flexNegative),
      })
    }
  },

  render: function()
  {
    var outerRad = this.props.height/2;
    var innerRad = outerRad - 1;
    return (
      <View key="outerMeter" style={[styles.meterContainer, {backgroundColor:this.props.outerColor, borderRadius:outerRad, height:this.props.height}, this.props.style]}>
        <View style={{width:innerRad*2, borderRadius:innerRad, backgroundColor:this.props.innerColor}}/>
        <Animated.View key="innerMeter" style={[{marginLeft:-innerRad, backgroundColor:this.props.innerColor, flex:this.state.flexPositive}]} />
        <View style={{width:innerRad*2, borderRadius:innerRad, marginLeft:-innerRad, backgroundColor:this.props.innerColor, alignItems:'center', justifyContent:'center'}}>
          {this.props.children}
        </View>
        <Animated.View key="negativeMeter" style={[{flex:this.state.flexNegative, borderRadius:innerRad}]} />
      </View>
    )
  }
});

var styles = StyleSheet.create({
  // meter
  meterContainer: {
    flexDirection:'row',
    padding:1,
  },
});

module.exports = Meter;
